import { render } from "./RequestCode.vue?vue&type=template&id=4de987f6"
import script from "./RequestCode.vue?vue&type=script&lang=js"
export * from "./RequestCode.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carterharrison/Documents/github/cf/api-platform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__